import type { FC, ReactElement, ReactNode } from "react";
import { useMineInfo } from "../contexts/mine-info-context";
import { useSettingsPermission } from "../pages/setting/document/decentralization/hooks/use-settings-permission";
import { useUser } from "./use-user";

interface Props {
  fallback?: ReactNode;
  role: string | string[];
  children?: ReactNode;
  permissions?: string[];
}

const Permission: FC<Props> = ({ role, fallback = null, children, permissions = [] }): ReactElement | null => {
  const { data } = useSettingsPermission();
  const { email } = useUser();
  const { checkPermission } = useMineInfo();

  const roles = Array.isArray(role) ? role : [role];

  const hasPermission = roles.some((role) => {
    const group = data?.find((g: any) => g?.eGroupCode === role);
    if (group && group.Members) {
      const members = JSON.parse(group.Members);
      return members.some((member: any) => member.email.toLowerCase() === email.toLowerCase());
    }
    return false;
  });

  return hasPermission || permissions.some(checkPermission)
    ? (children as ReactElement | null)
    : (fallback as ReactElement | null);
};

export default Permission;
